import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Articles() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Access comprehensive travel guides and resources on First-Class.com. Find articles packed with tips, recommendations, and expert insights'
          }
        />
        <title>Guide Articles: In-Depth Travel Planning Advice</title>
      </Head>
      <ArticlesList subtype="Articles" type="Guides" />
    </>
  );
}

export default withLayout(Articles, true);
